import React from "react"

export default class phoneInput extends React.Component
{
    constructor(props)    
    {
        super(props);

        this.zChar = [' ', '(', ')', '-', '.'];
        this.maxphonelength = 14;
        this.phonevalue1 = '';
        this.phonevalue2 = '';
        this.cursorposition = '';

        this.handleKeyUp = this.backspacerUP.bind(this);
        this.handleKeyDown = this.backspacerDOWN.bind(this);
    }

    ParseForNumber1 = (object) =>
    {        
        this.phonevalue1 = this.ParseChar(object.value, this.zChar);
    }
    
    ParseForNumber2 = (object) =>
    {
        this.phonevalue2 = this.ParseChar(object.value, this.zChar);
    }
    
    backspacerUP = (event) =>
    {            
        const e = event !== undefined ? event : window.event;
        const keycode = e.which !== false ? e.which : e.keyCode;
        const object = e.target;

        this.ParseForNumber1(object)
    
        if (keycode >= 48) 
        {
            this.ValidatePhone(object)
        }
    }
    
    backspacerDOWN = (event) =>
    {    
        const e = event !== undefined ? event : window.event;        
        const object = e.target;

        this.ParseForNumber2(object);
    }
    
    GetCursorPosition = () =>
    {    
        const t1 = this.phonevalue1;
        const t2 = this.phonevalue2;
        let bool = false;

        for (let i = 0; i < t1.length; i++) 
        {
            if (t1.substring(i, 1) !== t2.substring(i, 1)) 
            {
                if (!bool) 
                {
                    this.cursorposition = i
                    bool = true
                }
            }
        }
    }
    
    ValidatePhone = (object) =>
    {    
        let p = this.phonevalue1
    
        p = p.replace(/[^\d]*/gi, "")
    
        if (p.length < 3) 
        {
            object.value = p
        } 
        else if (p.length === 3) 
        {
            let pp = p;
            let d4 = p.indexOf('(')
            let d5 = p.indexOf(')')

            if (d4 === -1) 
            {
                pp = "(" + pp;
            }

            if (d5 === -1) 
            {
                pp = pp + ")";
            }

            object.value = pp;
        } 
        else if (p.length > 3 && p.length < 7) 
        {
            p = "(" + p;
            let l30 = p.length;
            let p30 = p.substring(0, 4);
            p30 = p30 + ")"
    
            let p31 = p.substring(4, l30);
            let pp = p30 + p31;
    
            object.value = pp;
    
        } 
        else if (p.length >= 7) 
        {
            p = "(" + p;
            let l30 = p.length;
            let p30 = p.substring(0, 4);
            p30 = p30 + ") "
    
            let p31 = p.substring(4, l30);
            let pp = p30 + p31;
    
            let l40 = pp.length;
            let p40 = pp.substring(0, 9);
            p40 = p40 + "-"
    
            let p41 = pp.substring(9, l40);
            let ppp = p40 + p41;
    
            object.value = ppp.substring(0, this.maxphonelength);
        }   
    }
    
    ParseChar = (sStr, sChar) =>
    {        
        const zChar = sChar.length === null ? new Array(sChar) : sChar;  
        let sNewStr = "";     
   
        for (let i = 0; i < zChar.length; i++) 
        {
            sNewStr = "";
    
            let iStart = 0;
            let iEnd = sStr.indexOf(sChar[i]);
    
            while (iEnd !== -1) 
            {
                sNewStr += sStr.substring(iStart, iEnd);
                iStart = iEnd + 1;
                iEnd = sStr.indexOf(sChar[i], iStart);
            }
            
            sNewStr += sStr.substring(sStr.lastIndexOf(sChar[i]) + 1, sStr.length);
    
            sStr = sNewStr;
        }
    
        return sNewStr;
    }
   
    render()
    {
        return(
            <div>
            <b>+1</b> <input maxLength={this.maxphonelength} autoComplete="off" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} id="phone" type="text" name="phone" placeholder="Mobile Phone"/>
            </div>
        )     
    }
}